import { Switch } from 'antd'
import { useRolodexEdit } from 'features/fde'
import { usePointCloudContext } from 'features/pointClouds'
import { ControlLabel } from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'
import { GeckoPotreePointCloud, RolodexEntryPatchJson } from 'types'

export const LegacyRotationSwitch: React.FC<{
  pointCloud: GeckoPotreePointCloud
}> = ({ pointCloud }) => {
  const { rolodexPatch } = useRolodexEdit()

  const { enableLegacyRotation, setEnableLegacyRotation } =
    usePointCloudContext()

  const updateEnableLegacyRotation = (checked: boolean) => {
    setEnableLegacyRotation(checked)

    const patchData: RolodexEntryPatchJson = {
      id: pointCloud.id,
      data: {
        use_legacy_rotation: checked,
      },
    }

    rolodexPatch([patchData])
  }

  return (
    <>
      <ControlLabel>Legacy Rotation</ControlLabel>
      <Switch
        checked={enableLegacyRotation}
        onChange={updateEnableLegacyRotation}
      />
    </>
  )
}
